var _polygon, _polygon2, _path, _path2, _line, _line2, _polyline, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "5,21 11,21 21,11 21,5 5,5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "11,27 27,27 27,11 21,11 11,21 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8,16c4.3,0,6-2.4,6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M9,12c0,1.7,2.2,3,5,3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 8,
    y1: 10,
    x2: 16,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 12,
    y1: 10,
    x2: 12,
    y2: 8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    points: "22,24 22,23 20,17 20,17 18,23 18,24 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 18.4,
    y1: 22,
    x2: 21.6,
    y2: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.3098af3a683b782c90940aee70bb840c.svg";
export { ForwardRef as ReactComponent };